import appConfig from "../../appconfig";
import axios from "axios";
import { getComponentTranslations } from "./LocalizationProvider";

const axiosInstance = axios.create({
	timeout: 3000
});

export const getContent = async (store, languageCode, contentType, tenantId = null ) => {
	const isCatalogContent = contentType === "catalog";
	const component = (() => {
		if(isCatalogContent) {
			return `tid${tenantId || appConfig.tenantId}-catalog`;
		}

		return contentType;
	})();

	const { contentUrls: { staticRoot, catalogRoot } } = store.getters.serverData;
	const url = (isCatalogContent ? catalogRoot : staticRoot) + `/${component}/${languageCode}/file/`;

	const { data } = await axiosInstance.get(url);
	return data;
};

export const fetchComponentTranslations = async (vuexStore, locale, isAdmin, tenantId) => {
	try {
		const isDynamicLocalizationEnabled = typeof vuexStore.getters.featureToggles.dynamicLocalization !== "undefined"
			? vuexStore.getters.featureToggles.dynamicLocalization
			: appConfig.tenantConfig.enableDynamicLocalization;

		const { staticText, catalog } = await (async () => {
			if(appConfig.getBusinessModelId() === appConfig.businessModelsEnum.bm100.id) {
				const [ staticText, catalog ] = await Promise.all([
					getContent(vuexStore, locale, isAdmin ? "vue-admin" : "gt3", tenantId),
					...(isDynamicLocalizationEnabled ? [getContent(vuexStore, locale, "catalog", tenantId)] : [])
				]);

				return { staticText, catalog };
			}

			const result = await getComponentTranslations(locale, "staticText" + (isDynamicLocalizationEnabled ? "|catalog" : ""), isAdmin, tenantId);
			return isDynamicLocalizationEnabled ? result.data : { staticText: result.data, catalog: {} };
		})();

		return { staticText, catalog };
	} catch (err) {
		return {
			staticText: (vuexStore.getters.catalogs || {})[locale] || await import(`../../assets/translations/gt3/gt3${isAdmin ? "-full" : ""}_${locale}`),
			catalog: (vuexStore.getters.dynamicCatalog || {})[locale] || {}
		};
	}
};